import http from "../../shared/http";
import moment from 'moment';
import Vue from 'vue'

const config = {
    state: {
        user: null,
        permissions: null,
        permissionsList: [],
        isAdmin: false,
        roles: [],
        userCheckEvents: localStorage.getItem('user_check_events'),
        newEvents: 0,
        locale: localStorage.getItem('locale') || 'en_US',
        claims: null
    },
    actions: {
        fetchPermissions({commit, state}) {
            return new Promise((resolve, reject) => {
                if (state.permissions) {
                    return
                }

                http.get("/v1/user/role/permissions", {
                    headers: {
                        'X-Project-Uuid': localStorage.getItem('current_project_uuid')
                    }
                }).then((resp) => {
                    commit('SET_PERMISSIONS', resp.data)
                    resolve(resp.data)
                }).catch(err => {
                    reject(err)
                })
            })
        },

        fetchRoles({commit, state}, force) {
            return new Promise((resolve, reject) => {
                if (state.roles.length > 0 && !force) {
                    resolve(state.roles)
                    return
                }

                http.get("/v1/user/role/list").then((resp) => {
                    const roles = resp.data.filter(r => {
                        return !r.is_admin
                    })

                    commit('SET_ROLES', roles)
                    resolve(roles)
                }).catch(err => {
                    reject(err)
                }) 
            })
        },

        fetchPermissionsList({commit}) {
            return new Promise((resolve, reject) => {
                http.get("/v1/user/permissions/list").then((resp) => {
                    commit('SET_PERMISSIONS_LIST', resp.data)
                    resolve(resp.data)
                }).catch(err => {
                    reject(err)
                })
            })
        },

        fetchNewEventsCount({state}) {
            let time = moment(state.userCheckEvents).format("YYYY-MM-DD HH:mm:ss")
            http.get("/v1/system/events/new?time=" + time).then(resp => {
                state.newEvents = resp.data.count
            })
        },

        setUser({commit}) {
            return new Promise((resolve, reject) => {
                http.get("/v1/user/model").then(resp => {
                    commit('setUser', resp.data)
                    resolve(resp.data)
                }).catch(err => {
                    reject(err)
                })
            });
        },

        fetchClaims({commit, state}) {
            return new Promise((resolve, reject) => {
                if (state.claims) {
                    resolve(state.claims)
                    return 
                }

                http.get("/v1/user/claims").then(resp => {
                    console.log("claims")
                    if (!resp) {
                        reject(new Error("Invalid response"))
                        return
                    }

                    commit('setClaims', resp.data)
                    resolve(resp.data)
                }).catch(err => {
                    reject(err)
                })
            });
        }
    },
    mutations: {
        SET_PERMISSIONS(state, perm) {
            let { is_admin, permissions } = perm || {}
            
            Vue.set(state, 'isAdmin', is_admin || false)
            Vue.set(state, 'permissions', permissions)
        },

        SET_PERMISSIONS_LIST(state, permissions) {
            state.permissionsList = permissions
        },

        SET_ROLES(state, roles) {
            state.roles = roles
        },

        SET_LOCALE(state, locale) {
            localStorage.setItem('locale', locale)
            state.locale = locale
        },

        authSuccess(state, token) {
            state.token = token
        },
    
        setUser(state, user) {
            if (state.userCheckEvents == null) {
                localStorage.setItem("user_check_events", user.login_at)
                state.userCheckEvents = user.login_at
            }

            state.user = user 
        },

        setClaims(state, claims) {
            state.claims = claims 
        },

        SET_USER_CHECK_EVENTS(state) {
            state.userCheckEvents = moment().format()
            localStorage.setItem("user_check_events", state.userCheckEvents)
            state.newEvents = 0
        },

        SET_NEW_EVENT(state, count) {
            state.newEvents += count
        },

        SET_BILLING_ADDRESS(state, address) {
            state.user.settings.billing_address = address
        }
    },
    getters: {
        getUser(state) {
            return state.user;
        },

        getClaims(state) {
            return state.claims;
        },

        getUserTimezone(state) {
            return state.user.settings.timezone;
        },

        getLocale(state) {
            return state.locale
        },
    
        permissions(state) {
            return state.permissions;
        },

        permissionsList(state) {
            return state.permissionsList;
        },

        getRoles(state) {
            return state.roles;
        },

        isAdmin(state) {
            if (!state.claims) return false

            return state.claims.IsAdmin
        },

        userCheckEvents(state) {
            return state.userCheckEvents
        },

        newEventsCount(state) {
            return state.newEvents
        }
    }
  }

export default config